import styled from 'styled-components';

export const TabPhoneContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

